function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#231F20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.4 24 0 18.6 0 12S5.4 0 12 0s12 5.4 12 12-5.4 12-12 12zm0-20.9c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9 8.9-4 8.9-8.9-4-8.9-8.9-8.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.5 11l-5.2-3.8c-.3-.2-.8-.3-1.2-.1-.4.2-.7.7-.7 1.1v7.6c0 .5.3.9.7 1.1.2.1.4.1.5.1.3 0 .5-.1.7-.2l5.2-3.8c.3-.2.5-.6.5-1s-.2-.8-.5-1z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;